import React, { useEffect, useState } from 'react';
import './SideNav.css';
import axios from 'axios';
import config from '../../config';
import { Check2 } from 'react-bootstrap-icons';

const SideNav = ({  id,
                    active,
                    passed=[],
                    goToBasicContext,
                    goToDetailedContext,
                    goToAsphaltEmbodiedEmission,
                    goToConcreteEmbodiedEmission,
                    goToPedegreeMatrix,
                    goToPavementDesign,
                    goToResults,
                    isStateSelected = true,
                    onNavigationBlocked }) => {

    const [experimentStatus, setExperimentStatus] = useState({});

    const navItems = [
        { id: 'pavement-context-basic', label: 'Pavement Context', shortLabel: 'Context' },
        { id: 'pavement-context-custom', label: 'Detailed Context', shortLabel: 'Details' },
        { id: 'concrete-embodied-emission', label: 'Concrete Embodied Emission', shortLabel: 'Concrete' },
        { id: 'asphalt-embodied-emission', label: 'Asphalt Embodied Emission', shortLabel: 'Asphalt' },
        { id: 'pavement-design', label: 'Pavement Design', shortLabel: 'Design' },
    ];

    const getStepState = (itemId) => {
        if (active === itemId) return 'active';
        if (passed.includes(itemId)) return 'completed';
        return 'pending';
    };

    const isDisabled = (itemId) => {
        return !isStateSelected && active !== itemId;
    };

    const handleNavClick = (itemId) => {
        const handlers = {
            'pavement-context-basic': goToBasicContext,
            'pavement-context-custom': goToDetailedContext,
            'concrete-embodied-emission': goToConcreteEmbodiedEmission,
            'asphalt-embodied-emission': goToAsphaltEmbodiedEmission,
            'pavement-design': goToPavementDesign,
            'results': goToResults,
        };

        if (active === itemId || isStateSelected) {
            handlers[itemId]?.();
        } else {
            onNavigationBlocked?.();
        }
    };

    useEffect(() => {
        axios.get(`${config.apiUrl}/api/experiment/${id}`)
          .then((response) => {
            setExperimentStatus(response.data.status);
          })
          .catch((error) => {
            console.log(error);
          });
      }, [id]);

    const allItems = experimentStatus === 'COMPLETED'
        ? [...navItems, { id: 'results', label: 'Results', shortLabel: 'Results' }]
        : navItems;

    return (
        <>
            {/* Vertical sidebar - visible on desktop (992px+) */}
            <nav className="sidebar">
                <div className="sidebar-header">
                    <span className="sidebar-title">Progress</span>
                </div>
                <div className="steps">
                    {allItems.map((item, index) => {
                        const state = getStepState(item.id);
                        const disabled = isDisabled(item.id);
                        const isLast = index === allItems.length - 1;

                        return (
                            <div key={item.id} className="step-wrapper">
                                <button
                                    className={`step step--${state} ${disabled ? 'step--disabled' : ''}`}
                                    onClick={() => !disabled && handleNavClick(item.id)}
                                    disabled={disabled}
                                >
                                    <div className="step-indicator">
                                        <div className={`step-icon step-icon--${state}`}>
                                            {state === 'completed' ? (
                                                <Check2 size={14} />
                                            ) : (
                                                <span>{index + 1}</span>
                                            )}
                                        </div>
                                        {!isLast && <div className={`step-line step-line--${state === 'completed' ? 'completed' : 'pending'}`} />}
                                    </div>
                                    <div className="step-content">
                                        <span className="step-label">{item.label}</span>
                                    </div>
                                </button>
                            </div>
                        );
                    })}
                </div>
            </nav>

            {/* Horizontal stepper - visible on tablet/mobile (below 992px) */}
            <div className="sidebar-horizontal">
                {allItems.map((item, index) => {
                    const state = getStepState(item.id);
                    const disabled = isDisabled(item.id);

                    return (
                        <button
                            key={item.id}
                            className={`step-item step-item--${state} ${disabled ? 'step-item--disabled' : ''}`}
                            onClick={() => !disabled && handleNavClick(item.id)}
                            disabled={disabled}
                        >
                            <span className="step-number">
                                {state === 'completed' ? <Check2 size={12} /> : index + 1}
                            </span>
                            <span className="step-short-label">{item.shortLabel}</span>
                        </button>
                    );
                })}
            </div>
        </>
    );
};

export default SideNav;
